angular.module('app.print.header')

.controller('PrintHeaderCtrl', function($scope, $rootScope){


    $scope.timeline = (($rootScope.selectedPeriod && $rootScope.selectedPeriod.period) ? $rootScope.selectedPeriod.period.value : 7) + " days";

	$scope.$watch('titleType', function(newValue, oldValue) {
        switch(newValue) {
            case 'home':
                $scope.mainTitle = 'HOME - POSTS LAST ';
                $scope.isShowTimeLine = false;
                break;
            case 'discover-post':
                $scope.mainTitle = 'DISCOVER - POSTS';
                $scope.isShowTimeLine = false;
                break;
            case 'discover-influencer':
                $scope.mainTitle = 'DISCOVER - INFLUENCERS';
                $scope.isShowTimeLine = false;
                break;
            case 'Performance Report':
                $scope.mainTitle = 'PERFORMANCE REPORT';
                $scope.isShowTimeLine = true;
                break;
            case 'Exposure Report':
                $scope.mainTitle = 'EXPOSURE REPORT';
                $scope.isShowTimeLine = true;
                break;
            case 'Segmentation Report':
                $scope.mainTitle = 'SEGMENTATION REPORT';
                $scope.isShowTimeLine = true;
                break;
            case 'Insight Report':
                $scope.mainTitle = 'INSIGHT REPORT';
                $scope.isShowTimeLine = true;
                break;
            case 'Ranking Score Report':
                $scope.mainTitle = 'RANKING SCORE REPORT';
                $scope.isShowTimeLine = false;
                break;
            default:
                $scope.mainTitle = newValue;
                $scope.isShowTimeLine = true;
                break;
        }
    })

	$scope.pageTotal = 0;
    
	var loadData = function() {
		// header
		$scope.printHeader = $rootScope.printHeader;

		// date
    	var now = new Date();
        $scope.printDate = now.getDate() + '.' + (now.getMonth() + 1) + ' - ' + now.getFullYear();
	}

    $scope.pageTotal = function() {
        return $('.print-titles.print-header-directive-shown').length;
    }

    $scope.$on('updatePrintHeader', function(event, args){
    	// header
    	$scope.printHeader = args.printHeader;
    	$rootScope.printHeader = args.printHeader;
    	
    	// date
    	var now = new Date();
        $scope.printDate = now.getDate() + '.' + (now.getMonth() + 1) + ' - ' + now.getFullYear();
    })

    $scope.$on('refreshDashboard', function(event, args){
        if($rootScope.selectedPeriod.period != undefined || $rootScope.selectedPeriod.period != null) {
            $scope.timeline = $rootScope.selectedPeriod.period.value + " days";
        }
    });

    loadData();
})
